export default __webpack_public_path__ + "static/media/englishstar_logo.ceb8777b.png";